export default __webpack_public_path__ + "static/media/ym.7ff11512.svg";